<template>
  <v-card
    dark
    class="primary darken-1"
    height="327"
    :min-width="minWidth"
    :width="width"
    style="border-radius: 5px; overflow-y: auto"
  >
    <v-expand-transition>
      <div
        v-if="grantingEffluents"
        class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal"
      >
        <v-card-text class="secondary--text text--lighten-1 text-justify">
          <v-row>
            <v-col cols="6">
              <v-icon
                large
                color="secondary lighten-1"
                @click="toggleGrantingEffluents"
                >mdi-arrow-left-circle</v-icon
              >
            </v-col>
            <v-spacer />
            <v-col cols="6" align-self="end" align="end">
              <v-icon large color="secondary lighten-1"
                >$effluentsGrantingBase</v-icon
              >
            </v-col>
          </v-row>
          <br />
          {{ grantingEffluentsText }}
        </v-card-text>
      </div>
    </v-expand-transition>
    <div v-if="!grantingEffluents">
      <v-card-subtitle class="white--text text--white">
        <span class="textDate"
          ><v-icon small>restore</v-icon> atualizado em</span
        ><br />
        <span class="textDate" v-if="indicator">{{
          indicator.params.data_dado
        }}</span>
        <span class="textDate" v-else>dd/mm/aaaa</span>
      </v-card-subtitle>
      <v-card-title>
        <v-icon class="ml-n1" color="secondary lighten-1" large>
          $effluentsGrantingBase
        </v-icon>
      </v-card-title>
      <v-card-subtitle class="white--text text--white">
        <strong class="textTitle">Outorgas de Efluentes emitidas pelo IAT</strong>
        <v-tooltip right color="#1A232F">
          <template v-slot:activator="{on, attrs}">
            <v-icon
              class="ml-1"
              color="secondary lighten-1"
              v-bind="attrs"
              v-on="on"
              @click="toggleGrantingEffluents"
            >
              help_outline
            </v-icon>
          </template>
          <span>Clique para informações</span>
        </v-tooltip>
      </v-card-subtitle>
      <v-card-text class="white--text text--white">
        <v-row dense v-if="grantsEffluentsTotal && location">
          <v-col cols="12">
            <span class="textItem">Unidades</span>
          </v-col>
          <v-col cols="12">
            <strong
              v-if="grantsEffluentsTotal && location"
              class="textItemValue"
              >{{ '0 / ' + new Intl.NumberFormat("pt-BR").format(grantsEffluentsTotal.total) }}</strong
            >
          </v-col>
        </v-row>
        <v-row dense v-else>
          <v-col cols="12">
            <span class="textItem">Unidades</span>
          </v-col>
          <v-col cols="12">
            <strong
              v-if="grantsEffluentsTotal && !location"
              class="textItemValue"
              >{{ new Intl.NumberFormat("pt-BR").format(grantsEffluentsTotal.total) }}</strong
            >
            <strong v-if="grantsEffluents && location" class="textItemValue">{{
              grantsEffluents.totalFormatted
            }}</strong>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'CardGrantingEffluents',
  props: {
    minWidth: {
      required: false,
    },
    width: {
      required: false,
    },
    grantsEffluentsTotal: {
      required: true,
    },
    grantsEffluents: {
      required: true,
    },
    location: {
      required: true,
    },
    indicator: {
      required: true,
    },
  },
  data() {
    return {
      grantingEffluents: false,
      grantingEffluentsText:
        'As outorgas de efluentes são geradas a partir das cargas solicitadas e outorgadas pelo IAT. As informações se referem a outorgas de efluentes de Indústrias e Estações de Tratamento de Esgoto (ETE) contidas nos mananciais, bem como análises por tipo de lançamento, por atividade da indústria, pela situação da outorga (se vigente, vencida, dispensa, em renovação), dentre outras.',
    };
  },
  methods: {
    toggleGrantingEffluents() {
      this.grantingEffluents = !this.grantingEffluents;
    },
  },
};
</script>

<style scoped>
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}
.textTitle {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}
.textItem {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
}
.textItemValue {
  font-family: Roboto;
  font-size: 32px;
  font-weight: 700;
}
/* width */
::-webkit-scrollbar {
  width: 7px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
